import * as defaultImport from "@splunk/react-ui/Multiselect";
export * from "@splunk/react-ui/Multiselect";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
